
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceConsumerUnitHistory: 'consumerUnitClientHistoryField.pesquisarHistoryByConsumerUnit',

  async load (params) {
    return await repository.resolve(this.nmInterfaceConsumerUnitHistory, { ...params })
  },

  loadHistoryDataByConsumerUnit: async function (consumerUnit) {
    return await repository.resolveDatatableModel(this.nmInterfaceConsumerUnitHistory, { consumerUnit: consumerUnit })
  },

  loadHistoryForm: async function () {
    return await repository.resolveDatatable(this.nmInterfaceConsumerUnitHistory)
  }
}
